import { render, staticRenderFns } from "./tag-cartao-proposta.vue?vue&type=template&id=a120b26e"
import script from "./tag-cartao-proposta.vue?vue&type=script&lang=js"
export * from "./tag-cartao-proposta.vue?vue&type=script&lang=js"
import style0 from "./tag-cartao-proposta.vue?vue&type=style&index=0&id=a120b26e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports